export default "__VITE_ASSET__ByQpYnC0__"